// extension from the Core product.model.ts
import { PromotionOrderEntryConsumed } from '@spartacus/cart/base/root';
import { Image, Price, Product, Promotion, Stock } from '@spartacus/core';

export enum VariantType {
  SIZE = 'Size',
  COLOR = 'Colour',
}
export interface Category {
  code?: string;
  name?: string;
  image?: Image;
  url?: string;
  type?: string;
}
export interface ReplacementProduct {
  code?: string;
  name?: string;
  stock?: Stock;
  thumbnail?: string;
}
export interface ProductReplacement extends Product {
  replacedBy?: ReplacementProduct;
  replacementOf?: ReplacementProduct;
}
export interface Brand {
  code?: string;
  name?: string;
}
export interface ProductSummary extends Product {
  brand?: Brand;
  ean?: string;
  upc?: string;
  modelName?: string;
  seriesName?: string;
}
export interface SalesRepStockData {
  leadTime?: number;
  stockLevel?: number[];
  stockLevelStatus?: string;
  warehouseName?: string;
}
export interface ProductLeadTime extends Product {
  manualAllocation?: any;
  leadTime?: number;
  salesRepStockData?: SalesRepStockData[];
}

export interface ShimanoProduct extends Product {
  srpPrice: Price;
  basePrice: Price;
}

export interface ShimanoPromotion extends Promotion {
  consumedEntries?: PromotionOrderEntryConsumed[];
  promotion?: Promotion;
}
